/* eslint-disable no-unused-vars */
export default {
  DISPATCH_PUSH: 'DISPATCH_PUSH',

  NEW_LOADS: 'NEW_LOADS',     // {id: x}
  EDIT_LOADS: 'EDIT_LOADS',    // {id: x}
  DELETE_LOADS: 'DELETE_LOADS',    // {id: x}
  NEW_DRIVER: 'NEW_DRIVER',    // {id: x}
  EDIT_DRIVER: 'EDIT_DRIVER',   // {id: x}
  DELETE_DRIVER: 'DELETE_DRIVER',   // {id: x}
  EDIT_DRIVER_GPS: 'EDIT_DRIVER_GPS',   // {id: x}
  // NEW_DOCUMENT: 'NEW_DOCUMENT',     // {id: x}
  // EDIT_DOCUMENT: 'EDIT_DOCUMENT',    // {id: x}
  // DELETE_DOCUMENT: 'DELETE_DOCUMENT',    // {id: x}
  // NEW_EXPENSE: 'NEW_EXPENSE',     // {id: x}
  // EDIT_EXPENSE: 'EDIT_EXPENSE',    // {id: x}
  // DELETE_EXPENSE: 'DELETE_EXPENSE',    // {id: x}
  DRIVER_SWITCH_GPS: 'DRIVER_SWITCH_GPS' // {id: x, switchInfo: 'on\off'}
}
